"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.hasFlag = exports.getFlags = exports.flagsPropType = exports.allFlags = void 0;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));

require("../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var allFlags = ["expandable-row-ordering", // v4 flags
"p-stateful", "use-portal", "add-button-margin", "expandable-row-class", "fix-discard-button", "fixed-messages-constants", "true-default", "v4", "new-alert-modal", "mouse-hover-select"];
exports.allFlags = allFlags;

var flagsPropType = _propTypes.default.arrayOf(_propTypes.default.oneOf(allFlags));

exports.flagsPropType = flagsPropType;

var getFlags = function getFlags(_ref) {
  var props = _ref.props,
      context = _ref.context;
  return (0, _flags.default)(props) || context && (0, _flags.default)(context) || [];
};

exports.getFlags = getFlags;

var hasFlag = function hasFlag(component, flag) {
  var flags = getFlags(component);
  return (0, _includes.default)(flags).call(flags, flag);
};

exports.hasFlag = hasFlag;